import QuickView from '../components/quickView';

export default class BlogArticle {
  constructor() {
    this.postCarousel = $('.greek .slider-article');
    this.quickViewModals = new QuickView('.modal');
    this.openQuickViewModalBtns = document.querySelectorAll('.quick-view button');

    this.articleVideo = document.querySelectorAll('.article-video');

    this.init();
    this.openQuickViewModalBtns.forEach((button) => {
      button.addEventListener('click', this.displayQuickViewModal.bind(this));
    });
  }

  init() {
    const articleVideoBlocks    = this.articleVideo

    articleVideoBlocks.forEach(videoBlock => {
      const videoPopup        = videoBlock.querySelector('.js-video-popup');
      const videoPopupVideo   = videoBlock.querySelector('.js-video-popup video');
      const cellVideo         = videoBlock.querySelector('.video-bg');
      const videoTrigger      = videoBlock.querySelector('.js-open-main-video');
      const videoClose        = videoBlock.querySelector('.js-close-main-video');

      console.log(cellVideo)

      videoTrigger.addEventListener('click', function(event) {
        event.preventDefault();

        const dataSrc       = this.dataset.src;
        const target        = document.querySelector(this.hash);
        const video         = target.querySelector('video');

        target.classList.add('popup-open');
        if (video != null) {
          video.setAttribute('src', dataSrc)
          video.play();
          cellVideo.pause();
        }
      });

      videoClose.addEventListener('click', function(event) {
        event.preventDefault();

        const target        = document.querySelector(this.hash);
        const video         = target.querySelector('video');

        cellVideo.play();

        target.classList.remove('popup-open');
        if (video != null) {
          video.pause();
        }
      });
    });

    // Initialize blog post carousels
    this.postCarousel.each(function() {
      const $container      = $(this);
      const $slidesImages   = $container.find('.js-slides-images');
      const $sliderPrev     = $container.find('.slider__prev');
      const $sliderNext     = $container.find('.slider__next');

      $slidesImages.slick({
        infinite: true,
        autoplay: true,
        dots: true,
        slidesToShow: 1,
        centerMode: true,
        centerPadding: '0',
        prevArrow: $sliderPrev,
        nextArrow: $sliderNext,
        adaptiveHeight: false,
        variableWidth: true,
        draggable: false,
        swipe: false,
        responsive: [
          {
            breakpoint: 1023,
            settings: {
              centerPadding: '20vw'
            }
          },
          {
            breakpoint: 767,
            settings: {
              centerPadding: '10vw'
            }
          }
        ]
      });
    });
  }

  /**
   * Display product quick view modal
   */
  displayQuickViewModal(e) {
    e.preventDefault();

    let target = e.target;
    while (!target.classList.contains('quick-view')) {
      target = target.parentElement;
    }

    const productId = target.dataset.productid;
    const variantId = target.dataset.variantid;
    const modal = document.getElementById(`quick-view-${productId}`);

    this.quickViewModals.previewVariant(modal, undefined, variantId);

    modal.style.display = 'flex';
  }
}
